import { render } from "./AttributeList.vue?vue&type=template&id=9777323a"
import script from "./AttributeList.vue?vue&type=script&lang=js"
export * from "./AttributeList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__